import {useEffect, useState} from "react";
import {useAuth} from "react-oidc-context";
import {get} from "./api";
import {applicationUrl, oidcServiceUrl, policyValidationEndpoint} from "./config";
import {usePrevious} from "./hooks";
import {redirect} from "./redirect";

const veracityUrl = "https://id.veracity.com";
const veracityHostname = "veracity.com";

export const useVeracityPolicy = (): {policyVerified: boolean; verificationError: string} => {
  const isVeracity = new URL(oidcServiceUrl).hostname.includes(veracityHostname);
  const [policyVerified, setPolicyVerified] = useState(!isVeracity);
  const [verificationError, setVerificationError] = useState<string>();
  const auth = useAuth();
  const wasAuthenticated = usePrevious(auth.isAuthenticated);

  useEffect(() => {
    if (isVeracity && auth.isAuthenticated && !wasAuthenticated) {
      get({
        url: policyValidationEndpoint,
        params: {"api-version": "2.0", redirectUri: applicationUrl}
      })
        .then(result => {
          if (result.data?.accepted) {
            setPolicyVerified(true);
            return;
          }

          const policyConsentUrl = result.data?.policyConsentUrl;

          if (new URL(policyConsentUrl).protocol.length === 0) {
            setVerificationError("Failed to navigate to Veracity Terms of Service.");
            return;
          }

          redirect(policyConsentUrl, veracityUrl);
        })
        .catch(_ => {
          setVerificationError(
            "Failed to verify that Veracity Terms of Service have been accepted."
          );
        });
    }
  }, [auth.isAuthenticated, wasAuthenticated]);

  return {policyVerified, verificationError};
};
